import { pinAtom } from "lib/globalState";
import { Redirect, Route } from "react-router";
import { useRecoilValue } from "recoil";


const ProtectedRoute = ({ component: Component, ...rest }) => {
    const pin = useRecoilValue(pinAtom)
    return (
        process.env.NODE_ENV === "development" ?
            <Route
                {...rest}
                render={props =>
                    <Component {...props} {...rest} />
                }
            />
            :
            <Route
                {...rest}
                render={props =>
                    pin && !isNaN(parseInt(pin)) ? (
                        <Component {...props} {...rest} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: "/404",
                                state: { from: props.location }
                            }}
                        />
                    )
                }
            />
    );
}

export default ProtectedRoute;